import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, ArrowRight, MessageCircle } from "lucide-react";
import SEO from "@/components/SEO";
import Overline from "@/components/Overline";
import { company, seo, buildQuoteUrl, whatsappUrl } from "@/config/site";

export default function Contact() {
  const wa = whatsappUrl();
  return (
    <>
      <SEO
        title="Contact"
        description={`Contact ${company.fullCompanyName} — Greater Noida, India. Phone ${company.phone}.`}
        canonical={`${seo.siteUrl}/contact`}
      />

      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <Overline>Contact</Overline>
          <h1 className="font-heading mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-neutral-900">Get in touch.</h1>
          <p className="mt-5 max-w-2xl text-neutral-600 leading-relaxed">
            Reach out with your packaging requirement. We're based in Greater Noida and typically respond during business hours.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-6">
          <div className="bg-white border border-neutral-200 p-6 rounded-sm">
            <MapPin className="text-[#A91D22]" aria-hidden="true" />
            <div className="mt-4 font-heading text-lg font-semibold text-neutral-900">Registered Address</div>
            <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{company.addressFull}</p>
          </div>
          <div className="bg-white border border-neutral-200 p-6 rounded-sm">
            <Phone className="text-[#A91D22]" aria-hidden="true" />
            <div className="mt-4 font-heading text-lg font-semibold text-neutral-900">Phone</div>
            <a href={company.phoneHref} className="mt-2 text-sm text-neutral-800 hover:text-[#A91D22] block" data-testid="contact-phone-link">{company.phone}</a>
          </div>
          <div className="bg-white border border-neutral-200 p-6 rounded-sm">
            <Mail className="text-[#A91D22]" aria-hidden="true" />
            <div className="mt-4 font-heading text-lg font-semibold text-neutral-900">Email</div>
            {company.email ? (
              <a href={`mailto:${company.email}`} className="mt-2 text-sm text-neutral-800 hover:text-[#A91D22] block" data-testid="contact-email-link">{company.email}</a>
            ) : (
              <p className="mt-2 text-sm text-neutral-500 leading-relaxed">Email address will be added shortly.</p>
            )}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 grid md:grid-cols-3 gap-3">
          <a href={company.phoneHref} className="inline-flex justify-center items-center gap-2 border border-neutral-900 text-neutral-900 px-6 py-3 text-sm font-medium hover:bg-neutral-900 hover:text-white rounded-sm" data-testid="contact-cta-call">
            <Phone size={16} /> Call Us
          </a>
          {company.email ? (
            <a href={`mailto:${company.email}`} className="inline-flex justify-center items-center gap-2 border border-neutral-300 text-neutral-900 px-6 py-3 text-sm font-medium hover:bg-neutral-50 rounded-sm" data-testid="contact-cta-email">
              <Mail size={16} /> Email Us
            </a>
          ) : null}
          <a href={buildQuoteUrl()} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 bg-[#A91D22] text-white px-6 py-3 text-sm font-medium hover:bg-[#8B181C] rounded-sm" data-testid="contact-cta-quote">
            Request a Quote <ArrowRight size={16} />
          </a>
          {wa ? (
            <a href={wa} target="_blank" rel="noopener noreferrer" className="md:col-span-3 inline-flex justify-center items-center gap-2 border border-neutral-300 text-neutral-900 px-6 py-3 text-sm font-medium hover:bg-neutral-50 rounded-sm">
              <MessageCircle size={16} /> Chat on WhatsApp
            </a>
          ) : null}
        </div>
      </section>
    </>
  );
}
